import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    backgroundColor: theme(props).semanticColors.warning.backgroundColor,
    textAlign: "center",
    padding: `40px 0`,
    marginTop: 20,
}));
